import React from "react";
import styled from "styled-components";
import { Icon } from "semantic-ui-react";
import { DateTimeBadge, DateBadge, DateDueBadge } from "../badges";

const Placeholder = styled.div`
  float: right;
  width: 75px;
  height: 75px;
  margin-right: 5px;
  border-radius: 5px;
`;

const PersonBadge = styled.div`
  display: inline-block;
  overflow: hidden;
  margin-right: 0.5rem;
`;

const BorderlessLabel = styled.span`
  font-size: 0.7em;
  margin-right: 5px;

  i.icon {
    margin: 0 !important;
    padding: 0 !important;
  }
`;

const TopicPlusLocation = styled.p`
  color: #000;
  opacity: 0.7;
  font-size: 12px;
  margin: 2px 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: no-wrap;
`;

export const MobileColumns = (crmRequestImages: any) => [
  {
    Header: "Topic+",
    Cell: (data: any) => {
      const caseId = data.row.original.caseId;
      const hasAttachment = data.row.original.hasAttachment !== 0;
      const isAttachmentImage = crmRequestImages[caseId] !== null;
      const hasPreview = hasAttachment && isAttachmentImage;
      const dateClosed = data.row.original.dateClosed;
      const location = data.row.original.location;

      return (
        <div style={{ height: "100%" }}>
          {hasPreview && (
            <Placeholder
              style={{
                background: `url(${crmRequestImages[caseId]}) no-repeat center`,
                backgroundSize: "cover",
              }}
            />
          )}
          <div>
            <h4 style={{ margin: 0 }}>
              <BorderlessLabel>
                <Icon name='hashtag' color='grey' />
                {data.row.original.displayId}
              </BorderlessLabel>
              <span style={{ color: "#F26C21", marginBottom: 3 }}>{data.row.original.topicName}</span>
            </h4>
            {location && location.length > 0 && (
              <TopicPlusLocation>
                <Icon name='map marker alternate' color='grey' />
                {location}
              </TopicPlusLocation>
            )}
            <div style={{ width: hasAttachment ? "calc(100% - 88px)" : "100%", overflow: "hidden" }}>
              <p className='tw-mb-1' style={{ display: "flex" }}>
                <PersonBadge>
                  <Icon name='clipboard' color='grey' />
                  {data.row.original.contactDisplayName}
                </PersonBadge>
                <PersonBadge>
                  <Icon name='user' color='grey' style={{ marginLeft: 3 }} />
                  {data.row.original.assignedToDisplayName}
                </PersonBadge>
              </p>
              {dateClosed && <DateBadge value={data.row.original.dateExpectClose} />}
              {!dateClosed && <DateDueBadge oneLine value={data.row.original.dateExpectClose} />}
              <DateTimeBadge oneline value={data.row.original.dateEntered} />
            </div>
          </div>
        </div>
      );
    },
    flexGrow: 1,
  },
];
